import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { LoadingSpinnerService } from 'src/app/shared/service/loading-spinner.service';


@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class LoadingSpinnerComponent {
  private readonly loadingSpinnerService = inject(LoadingSpinnerService);

  isLoading: Subject<boolean> = this.loadingSpinnerService.isLoading;
}